import type { EditControlProps } from '../../declare'
import { useEffect, useMemo } from 'react'
import { Input } from 'antd'
import { SettingOutlined } from '@ant-design/icons'
import { appStore } from 'src/stores'
import { $api, $consts } from 'src/plugins'
import { initFilter } from 'src/utils/common'

const SeriesNo = (props: EditControlProps) => {
  const disabled = useMemo(() => {
    const { __READONLY__, EDITABLE } = props.config
    return __READONLY__ || !EDITABLE || props.evtConfig?.disabled
  }, [props.config.__READONLY__, props.config.EDITABLE, props.evtConfig?.disabled])

  const handleGenerateRule = (disabled?: boolean) => {
    if (disabled) return

    const { OrgId } = appStore.current.headers
    const payload: any = initFilter({ OrgId })
    payload.Count = 1
    payload.CodeType = props.config.CODE_RULE_TYPE
    $api['app/genSystemCode'](payload).then((res: any) => {
      res && handleChange({ target: { value: res } })
    })
  }

  const handleChange = (evt: any) => {
    let value = evt.target.value
    const { CASE } = props.config
    switch (CASE) {
      case $consts['COMMON/CASE_TO_UPPER']:
        value && (value = String(value).toUpperCase())
        break
      case $consts['COMMON/CASE_TO_LOWWER']:
        value && (value = String(value).toLowerCase())
        break
    }
    props.onChange?.(value)
  }

  // 控件被禁止，且无序列号时候，需要生成个序列号
  useEffect(() => {
    // 定时是为了保证编辑表单详情已经加载完毕
    let timer = setTimeout(() => {
      if (!props.value && props.config.REQUIRED && disabled) {
        handleGenerateRule()
      }
    }, 1000)

    return () => clearTimeout(timer)
  }, [props.value, props.config.REQUIRED, disabled])

  const { PROMPT_INFO, CODE_RULE_TYPE } = props.config
  return (
    <Input
      disabled={disabled}
      placeholder={PROMPT_INFO}
      value={props.value}
      addonAfter={
        CODE_RULE_TYPE
          ? <SettingOutlined title='点击生成' onClick={() => handleGenerateRule(disabled)} className='cursor-pointer' />
          : undefined
      }
      onChange={handleChange}
    />
  )
}

export default SeriesNo